import React, {  useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import usa_location from "../assets/contactUs/us.jpg"
import uae_location from "../assets/contactUs/uae.jpg"
import uk_location from "../assets/contactUs/uk.jpg"
import pk_location from "../assets/contactUs/pk.jpg"
import { BsCheckCircleFill } from "react-icons/bs";
import { FaStar } from "react-icons/fa";
import testimonial_1 from "../assets/testimonial/author-1.jpg";
import testimonial_2 from "../assets/testimonial/author-2.jpg";
import { Helmet } from "react-helmet";


const ContactUs = () => {
  const [hoveredOffice, setHoveredOffice] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState("PK");
  const [phoneNumber, setPhoneNumber] = useState("");
  const contactFormRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0); // This will move the user to the top of the page
  }, []);

  const testimonials = [
    {
      id: 1,
      name: "Magnus Olsson",
      position: "Co-Founder, Careem",
      text: "...it also felt like having our own engineering crew sitting with us in Dubai!",
      image:testimonial_1,
      },
    {
      id: 2,
      name: "Racha Zarzour",
      position: "Acting CEO, Droobi",
      text: "They are committed & persistent, have exceptional customer service skills, technical experience & knowledge.",
      image:testimonial_2, 
    },
  ];
  const businessGoals = [
    "Digital Transformation / BPO",
    "Modernise Legacy Systems & Technology",
    "Develop Robust Apps & Products",
    "Unlock Value With Data & Analytics",
    "Scale or Build In-house Tech Teams",
    "Create Stunning Digital Experiences",
  ];
  
  const countries = [
    { code: "AF", name: "Afghanistan", phoneCode: "+93" },
    { code: "AL", name: "Albania", phoneCode: "+355" },
    { code: "DZ", name: "Algeria", phoneCode: "+213" },
    { code: "AS", name: "American Samoa", phoneCode: "+1684" },
    { code: "AD", name: "Andorra", phoneCode: "+376" },
    { code: "AO", name: "Angola", phoneCode: "+244" },
    { code: "AI", name: "Anguilla", phoneCode: "+1264" },
    { code: "AG", name: "Antigua and Barbuda", phoneCode: "+1268" },
    { code: "AR", name: "Argentina", phoneCode: "+54" },
    { code: "AM", name: "Armenia", phoneCode: "+374" },
    { code: "AW", name: "Aruba", phoneCode: "+297" },
    { code: "AU", name: "Australia", phoneCode: "+61" },
    { code: "AT", name: "Austria", phoneCode: "+43" },
    { code: "AZ", name: "Azerbaijan", phoneCode: "+994" },
    { code: "BS", name: "Bahamas", phoneCode: "+1-242" },
    { code: "BH", name: "Bahrain", phoneCode: "+973" },
    { code: "BD", name: "Bangladesh", phoneCode: "+880" },
    { code: "BB", name: "Barbados", phoneCode: "+1246" },
    { code: "BY", name: "Belarus", phoneCode: "+375" },
    { code: "BE", name: "Belgium", phoneCode: "+32" },
    { code: "BZ", name: "Belize", phoneCode: "+501" },
    { code: "BJ", name: "Benin", phoneCode: "+229" },
    { code: "BM", name: "Bermuda", phoneCode: "+1-441" },
    { code: "BT", name: "Bhutan", phoneCode: "+975" },
    { code: "BO", name: "Bolivia", phoneCode: "+591" },
    { code: "BA", name: "Bosnia and Herzegovina", phoneCode: "+387" },
    { code: "BW", name: "Botswana", phoneCode: "+267" },
    { code: "BR", name: "Brazil", phoneCode: "+55" },
    { code: "BN", name: "Brunei", phoneCode: "+673" },
    { code: "BG", name: "Bulgaria", phoneCode: "+359" },
    { code: "BF", name: "Burkina Faso", phoneCode: "+226" },
    { code: "BI", name: "Burundi", phoneCode: "+257" },
    { code: "KH", name: "Cambodia", phoneCode: "+855" },
    { code: "CM", name: "Cameroon", phoneCode: "+237" },
    { code: "CA", name: "Canada", phoneCode: "+1" },
    { code: "CV", name: "Cape Verde", phoneCode: "+238" },
    { code: "KY", name: "Cayman Islands", phoneCode: "+1345" },
    { code: "CF", name: "Central African Republic", phoneCode: "+236" },
    { code: "TD", name: "Chad", phoneCode: "+235" },
    { code: "CL", name: "Chile", phoneCode: "+56" },
    { code: "CN", name: "China", phoneCode: "+86" },
    { code: "CO", name: "Colombia", phoneCode: "+57" },
    { code: "KM", name: "Comoros", phoneCode: "+269" },
    { code: "CG", name: "Congo (Congo-Brazzaville)", phoneCode: "+242" },
    { code: "CD", name: "Congo (Congo-Kinshasa)", phoneCode: "+243" },
    { code: "CR", name: "Costa Rica", phoneCode: "+506" },
    { code: "HR", name: "Croatia", phoneCode: "+385" },
    { code: "CU", name: "Cuba", phoneCode: "+53" },
    { code: "CY", name: "Cyprus", phoneCode: "+357" },
    { code: "CZ", name: "Czech Republic", phoneCode: "+420" },
    { code: "DK", name: "Denmark", phoneCode: "+45" },
    { code: "DJ", name: "Djibouti", phoneCode: "+253" },
    { code: "DM", name: "Dominica", phoneCode: "+1767" },
    { code: "DO", name: "Dominican Republic", phoneCode: "+1" },
    { code: "EC", name: "Ecuador", phoneCode: "+593" },
    { code: "EG", name: "Egypt", phoneCode: "+20" },
    { code: "SV", name: "El Salvador", phoneCode: "+503" },
    { code: "GQ", name: "Equatorial Guinea", phoneCode: "+240" },
    { code: "ER", name: "Eritrea", phoneCode: "+291" },
    { code: "EE", name: "Estonia", phoneCode: "+372" },
    { code: "SZ", name: "Eswatini", phoneCode: "+268" },
    { code: "ET", name: "Ethiopia", phoneCode: "+251" },
    { code: "FK", name: "Falkland Islands", phoneCode: "+500" },
    { code: "FO", name: "Faroe Islands", phoneCode: "+298" },
    { code: "FJ", name: "Fiji", phoneCode: "+679" },
    { code: "FI", name: "Finland", phoneCode: "+358" },
    { code: "FR", name: "France", phoneCode: "+33" },
    { code: "GF", name: "French Guiana", phoneCode: "+594" },
    { code: "PF", name: "French Polynesia", phoneCode: "+689" },
    { code: "GA", name: "Gabon", phoneCode: "+241" },
    { code: "GM", name: "Gambia", phoneCode: "+220" },
    { code: "GE", name: "Georgia", phoneCode: "+995" },
    { code: "DE", name: "Germany", phoneCode: "+49" },
    { code: "GH", name: "Ghana", phoneCode: "+233" },
    { code: "GI", name: "Gibraltar", phoneCode: "+350" },
    { code: "GR", name: "Greece", phoneCode: "+30" },
    { code: "GL", name: "Greenland", phoneCode: "+299" },
    { code: "GD", name: "Grenada", phoneCode: "+1-473" },
    { code: "GU", name: "Guam", phoneCode: "+1671" },
    { code: "GT", name: "Guatemala", phoneCode: "+502" },
    { code: "GN", name: "Guinea", phoneCode: "+224" },
    { code: "GW", name: "Guinea-Bissau", phoneCode: "+245" },
    { code: "GY", name: "Guyana", phoneCode: "+592" },
    { code: "HT", name: "Haiti", phoneCode: "+509" },
    { code: "HN", name: "Honduras", phoneCode: "+504" },
    { code: "HK", name: "Hong Kong", phoneCode: "+852" },
    { code: "HU", name: "Hungary", phoneCode: "+36" },
    { code: "IS", name: "Iceland", phoneCode: "+354" },
    { code: "IN", name: "India", phoneCode: "+91" },
    { code: "ID", name: "Indonesia", phoneCode: "+62" },
    { code: "IR", name: "Iran", phoneCode: "+98" },
    { code: "IQ", name: "Iraq", phoneCode: "+964" },
    { code: "IE", name: "Ireland", phoneCode: "+353" },
    { code: "IL", name: "Israel", phoneCode: "+972" },
    { code: "IT", name: "Italy", phoneCode: "+39" },
    { code: "CI", name: "Ivory Coast", phoneCode: "+225" },
    { code: "JM", name: "Jamaica", phoneCode: "+1-876" },
    { code: "JP", name: "Japan", phoneCode: "+81" },
    { code: "JO", name: "Jordan", phoneCode: "+962" },
    { code: "KZ", name: "Kazakhstan", phoneCode: "+7" },
    { code: "KE", name: "Kenya", phoneCode: "+254" },
    { code: "KI", name: "Kiribati", phoneCode: "+686" },
    { code: "KW", name: "Kuwait", phoneCode: "+965" },
    { code: "KG", name: "Kyrgyzstan", phoneCode: "+996" },
    { code: "LA", name: "Laos", phoneCode: "+856" },
    { code: "LV", name: "Latvia", phoneCode: "+371" },
    { code: "LB", name: "Lebanon", phoneCode: "+961" },
    { code: "LS", name: "Lesotho", phoneCode: "+266" },
    { code: "LR", name: "Liberia", phoneCode: "+231" },
    { code: "LY", name: "Libya", phoneCode: "+218" },
    { code: "LI", name: "Liechtenstein", phoneCode: "+423" },
    { code: "LT", name: "Lithuania", phoneCode: "+370" },
    { code: "LU", name: "Luxembourg", phoneCode: "+352" },
    { code: "MO", name: "Macau", phoneCode: "+853" },
    { code: "MK", name: "North Macedonia", phoneCode: "+389" },
    { code: "MG", name: "Madagascar", phoneCode: "+261" },
    { code: "MW", name: "Malawi", phoneCode: "+265" },
    { code: "MY", name: "Malaysia", phoneCode: "+60" },
    { code: "MV", name: "Maldives", phoneCode: "+960" },
    { code: "ML", name: "Mali", phoneCode: "+223" },
    { code: "MT", name: "Malta", phoneCode: "+356" },
    { code: "MH", name: "Marshall Islands", phoneCode: "+692" },
    { code: "MQ", name: "Martinique", phoneCode: "+596" },
    { code: "MR", name: "Mauritania", phoneCode: "+222" },
    { code: "MU", name: "Mauritius", phoneCode: "+230" },
    { code: "YT", name: "Mayotte", phoneCode: "+262" },
    { code: "MX", name: "Mexico", phoneCode: "+52" },
    { code: "FM", name: "Micronesia", phoneCode: "+691" },
    { code: "MD", name: "Moldova", phoneCode: "+373" },
    { code: "MC", name: "Monaco", phoneCode: "+377" },
    { code: "MN", name: "Mongolia", phoneCode: "+976" },
    { code: "ME", name: "Montenegro", phoneCode: "+382" },
    { code: "MS", name: "Montserrat", phoneCode: "+1-664" },
    { code: "MA", name: "Morocco", phoneCode: "+212" },
    { code: "MZ", name: "Mozambique", phoneCode: "+258" },
    { code: "MM", name: "Myanmar", phoneCode: "+95" },
    { code: "NA", name: "Namibia", phoneCode: "+264" },
    { code: "NR", name: "Nauru", phoneCode: "+674" },
    { code: "NP", name: "Nepal", phoneCode: "+977" },
    { code: "NL", name: "Netherlands", phoneCode: "+31" },
    { code: "NC", name: "New Caledonia", phoneCode: "+687" },
    { code: "NZ", name: "New Zealand", phoneCode: "+64" },
    { code: "NI", name: "Nicaragua", phoneCode: "+505" },
    { code: "NE", name: "Niger", phoneCode: "+227" },
    { code: "NG", name: "Nigeria", phoneCode: "+234" },
    { code: "NU", name: "Niue", phoneCode: "+683" },
    { code: "NF", name: "Norfolk Island", phoneCode: "+672" },
    { code: "MP", name: "Northern Mariana Islands", phoneCode: "+1670" },
    { code: "NO", name: "Norway", phoneCode: "+47" },
    { code: "OM", name: "Oman", phoneCode: "+968" },
    { code: "PK", name: "Pakistan", phoneCode: "+92" },
    { code: "PW", name: "Palau", phoneCode: "+680" },
    { code: "PA", name: "Panama", phoneCode: "+507" },
    { code: "PG", name: "Papua New Guinea", phoneCode: "+675" },
    { code: "PY", name: "Paraguay", phoneCode: "+595" },
    { code: "PE", name: "Peru", phoneCode: "+51" },
    { code: "PH", name: "Philippines", phoneCode: "+63" },
    { code: "PL", name: "Poland", phoneCode: "+48" },
    { code: "PT", name: "Portugal", phoneCode: "+351" },
    { code: "PR", name: "Puerto Rico", phoneCode: "+1" },
    { code: "QA", name: "Qatar", phoneCode: "+974" },
    { code: "RO", name: "Romania", phoneCode: "+40" },
    { code: "RU", name: "Russia", phoneCode: "+7" },
    { code: "RW", name: "Rwanda", phoneCode: "+250" },
    { code: "RE", name: "Réunion", phoneCode: "+262" },
    { code: "BL", name: "Saint Barthélemy", phoneCode: "+590" },
    { code: "SH", name: "Saint Helena", phoneCode: "+290" },
    { code: "KN", name: "Saint Kitts and Nevis", phoneCode: "+1-869" },
    { code: "LC", name: "Saint Lucia", phoneCode: "+1758" },
    { code: "MF", name: "Saint Martin", phoneCode: "+590" },
    { code: "PM", name: "Saint Pierre and Miquelon", phoneCode: "+508" },
    { code: "VC", name: "Saint Vincent and the Grenadines", phoneCode: "+1784" },
    { code: "WS", name: "Samoa", phoneCode: "+685" },
    { code: "SM", name: "San Marino", phoneCode: "+378" },
    { code: "ST", name: "São Tomé and Príncipe", phoneCode: "+239" },
    { code: "SA", name: "Saudi Arabia", phoneCode: "+966" },
    { code: "SN", name: "Senegal", phoneCode: "+221" },
    { code: "RS", name: "Serbia", phoneCode: "+381" },
    { code: "SC", name: "Seychelles", phoneCode: "+248" },
    { code: "SL", name: "Sierra Leone", phoneCode: "+232" },
    { code: "SG", name: "Singapore", phoneCode: "+65" },
    { code: "SX", name: "Sint Maarten", phoneCode: "+1-721" },
    { code: "SK", name: "Slovakia", phoneCode: "+421" },
    { code: "SI", name: "Slovenia", phoneCode: "+386" },
    { code: "SB", name: "Solomon Islands", phoneCode: "+677" },
    { code: "SO", name: "Somalia", phoneCode: "+252" },
    { code: "ZA", name: "South Africa", phoneCode: "+27" },
    { code: "GS", name: "South Georgia and the South Sandwich Islands", phoneCode: "+500" },
    { code: "KR", name: "South Korea", phoneCode: "+82" },
    { code: "SS", name: "South Sudan", phoneCode: "+211" },
    { code: "ES", name: "Spain", phoneCode: "+34" },
    { code: "LK", name: "Sri Lanka", phoneCode: "+94" },
    { code: "SD", name: "Sudan", phoneCode: "+249" },
    { code: "SR", name: "Suriname", phoneCode: "+597" },
    { code: "SJ", name: "Svalbard and Jan Mayen", phoneCode: "+47" },
    { code: "SE", name: "Sweden", phoneCode: "+46" },
    { code: "CH", name: "Switzerland", phoneCode: "+41" },
    { code: "SY", name: "Syria", phoneCode: "+963" },
    { code: "TW", name: "Taiwan", phoneCode: "+886" },
    { code: "TJ", name: "Tajikistan", phoneCode: "+992" },
    { code: "TZ", name: "Tanzania", phoneCode: "+255" },
    { code: "TH", name: "Thailand", phoneCode: "+66" },
    { code: "TL", name: "Timor-Leste", phoneCode: "+670" },
    { code: "TG", name: "Togo", phoneCode: "+228" },
    { code: "TK", name: "Tokelau", phoneCode: "+690" },
    { code: "TO", name: "Tonga", phoneCode: "+676" },
    { code: "TT", name: "Trinidad and Tobago", phoneCode: "+1-868" },
    { code: "TN", name: "Tunisia", phoneCode: "+216" },
    { code: "TR", name: "Turkey", phoneCode: "+90" },
    { code: "TM", name: "Turkmenistan", phoneCode: "+993" },
    { code: "TC", name: "Turks and Caicos Islands", phoneCode: "+1-649" },
    { code: "TV", name: "Tuvalu", phoneCode: "+688" },
    { code: "UG", name: "Uganda", phoneCode: "+256" },
    { code: "UA", name: "Ukraine", phoneCode: "+380" },
    { code: "AE", name: "United Arab Emirates", phoneCode: "+971" },
    { code: "GB", name: "United Kingdom", phoneCode: "+44" },
    { code: "US", name: "United States", phoneCode: "+1" },
    { code: "UY", name: "Uruguay", phoneCode: "+598" },
    { code: "UZ", name: "Uzbekistan", phoneCode: "+998" },
    { code: "VU", name: "Vanuatu", phoneCode: "+678" },
    { code: "VA", name: "Vatican City", phoneCode: "+379" },
    { code: "VE", name: "Venezuela", phoneCode: "+58" },
    { code: "VN", name: "Vietnam", phoneCode: "+84" },
    { code: "WF", name: "Wallis and Futuna", phoneCode: "+681" },
    { code: "EH", name: "Western Sahara", phoneCode: "+212" },
    { code: "YE", name: "Yemen", phoneCode: "+967" },
    { code: "ZM", name: "Zambia", phoneCode: "+260" },
    { code: "ZW", name: "Zimbabwe", phoneCode: "+263" }
  ];

  const offices = [
    {
      id: 1,
      name: "United States",
      image: usa_location,
      city :"Dublin",
      location: "Apartment 202, Dublin, Ohio, 43016",
    },
    {
      id: 2,
      name: "Pakistan",
      image: pk_location,
      city:"Lahore",
      location: "M10 , Mezzanine Floor , Siddiq Trade Center, Main Boulevard Gulberg, Block H Gulberg 2, Lahore",
      phone:"(042) 35817087"
    },
    {
      id: 3,
      name: "United Arab Emirates",
      image: uae_location,
      city:"Dubai",
      location: "Dubai, UAE",
    },
    {
      id: 4,
      name: "United Kingdom",
      image: uk_location,
      city:"London",
      location: "One Elmfield Park, BR1 1LU, London",
    },
    
  ];


 
  // Get the phone code for the selected country
  const selectedCountryData = countries.find(
    (country) => country.code === selectedCountry
  );
  const phoneCode = selectedCountryData ? selectedCountryData.phoneCode : "+92"; // Default to Pakistan if no match

  const handlePhoneNumberChange = (e) => {
    // Strip any non-numeric characters from the phone number input
    const value = e.target.value.replace(/\D/g, "");
    setPhoneNumber(value);
  };

   // Function to scroll to the contact form
   const handleScrollToForm = () => {
    contactFormRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
<Helmet>
  <title>Contact Us | Appnexts – Let's Build Something Great Together</title>
  <meta
    name="description"
    content="Have a project in mind? Contact Appnexts for expert web development, mobile app solutions, SEO services, and more. We're here to help you grow online."
  />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.appnexts.com/contact-us" />

  {/* Open Graph Meta Tags */}
  <meta property="og:title" content="Contact Us | Appnexts" />
  <meta property="og:description" content="Reach out to Appnexts for custom digital solutions. Whether it's a website, app, or SEO help – we're just a message away." />
  <meta property="og:image" content="https://www.appnexts.com/seo_image/contact_us_seo.png" />
  <meta property="og:url" content="https://www.appnexts.com/contact-us" />
  <meta property="og:type" content="website" />

  {/* Twitter Card Meta Tags */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Contact Appnexts | Custom Digital Services" />
  <meta name="twitter:description" content="Let’s connect and turn your idea into reality. Appnexts is your partner in web, mobile, and SEO development." />
  <meta name="twitter:image" content="https://www.appnexts.com/seo_image/contact_us_seo.png" />

  {/* Structured Data: Contact Page */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ContactUs",
      "name": "Contact Us - AppNexts",
      "description": "AppNexts is a leading provider of digital solutions specializing in app development, web design, SEO, and custom IT solutions to help businesses grow.",
      "url": "https://www.appnexts.com/contact-us",
      "image": {
        "@type": "ImageObject",
        "url": "https://www.appnexts.com/seo_image/contact_us_seo.png",
        "width": 1200,
        "height": 630
      },
      "publisher": {
        "@type": "Organization",
        "name": "AppNexts",
        "url": "https://www.appnexts.com",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.appnexts.com/seo_image/appnexts.png"
        }
      },
      "sameAs": [
        "https://www.facebook.com/people/Appnexts/61568551576819",
        "https://www.linkedin.com/company/appnexts",
        "https://www.youtube.com/@AppNexts"
      ],
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+923092018872",
        "email": "contact@appnexts.com",
        "contactType": "Customer Service",
        "areaServed": ["PK", "US", "IN"],
        "availableLanguage": ["English", "Urdu"]
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "M10 Mezzanine Floor, Siddiq Trade Center, Main Boulevard Gulberg Block H, Gulberg 2",
        "addressLocality": "Lahore",
        "addressRegion": "Punjab",
        "postalCode": "54000",
        "addressCountry": "PK"
      }
    })}
  </script>
</Helmet>




   <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        {/* Left Column */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="space-y-6"
        >
          <h3 className="text-[#504e9a] font-medium">Let&apos;s connect</h3>
          <h2 className="text-4xl font-bold text-gray-900 leading-tight">
            Get in touch to build scalable digital solutions. In weeks, not months.
          </h2>
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-[#5f5ca8] text-white px-6 py-3 rounded-md hover:bg-[#504e9a] transition-colors"
            onClick={handleScrollToForm}
         >
            Drop a message
          </motion.button>
        </motion.div>

        {/* Right Column - Testimonials */}
        <div className="space-y-8 relative">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className={`bg-gray-100 shadow-md rounded-lg p-6 relative ${index === 1 ? "ml-12" : ""}`}
            >
              {/* Star Rating */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <FaStar key={i} className="text-red-500 w-5 h-5" />
                ))}
              </div>

              {/* Quote */}
              <blockquote className="text-gray-700 mb-4">&quot;{testimonial.text}&quot;</blockquote>

              {/* Author Info */}
              <div className="flex items-center justify-between">
              <p className="font-semibold">
            {testimonial.name} <span className="text-gray-500">({testimonial.position})</span>
          </p>

                {/* Profile Image */}
                <div className="relative w-20 h-20 overflow-hidden  rounded-full shadow-lg">
                  <img
                    src={testimonial.image || "/placeholder.svg"}
                    alt={testimonial.name}
                    fill
                    className="object-cover"
                  />
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>

  <div ref={contactFormRef} className="bg-gray-100 py-4 lg:py-16">
    <div className="max-w-7xl mx-auto p-10 lg:p-8">
      <div className="grid lg:grid-cols-2 gap-12">
        {/* Left Column */}
        <div className="space-y-8">
          <div className="mt-8">
            <h2 className="text-[#504e9a] font-medium">Tell us about your project</h2>
          </div>
          <h1 className="text-4xl font-bold text-gray-900">
            What's your immediate business goal?
          </h1>
          <div className="space-y-8">
            {businessGoals.map((goal, index) => (
              <motion.div
                key={goal}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="flex items-start gap-3"
              >
                <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.9 }}>
                  <BsCheckCircleFill className="h-6 w-6 text-emerald-500 flex-shrink-0 mt-0.5" />
                </motion.div>
                <span className="text-gray-700 text-lg">{goal}</span>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Right Column - Form */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-white rounded-lg p-6 space-y-6 shadow-lg"
        >
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="space-y-2">
              <label htmlFor="firstName" className="text-sm text-gray-600">
                First name<span className="text-red-500">*</span>
              </label>
              <input
                id="firstName"
                className="w-full border bg-gray-100 border-gray-300 rounded-md p-2"
                required
              />
            </div>
            <div className="space-y-2">
              <label htmlFor="lastName" className="text-sm text-gray-600">
                Last name<span className="text-red-500">*</span>
              </label>
              <input
                id="lastName"
                className="w-full border bg-gray-100 border-gray-300 rounded-md p-2"
                required
              />
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="company" className="text-sm text-gray-600">
              Company name
            </label>
            <input
              id="company"
              className="w-full border bg-gray-100 border-gray-300 rounded-md p-2"
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="email" className="text-sm text-gray-600">
              Business email<span className="text-red-500">*</span>
            </label>
            <input
              id="email"
              type="email"
              className="w-full border bg-gray-100 border-gray-300 rounded-md p-2"
              required
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="phone" className="text-sm text-gray-600">
              Phone number<span className="text-red-500">*</span>
            </label>
            <div className="grid grid-cols-[180px_1fr] gap-2">
              <select
                id="country"
                className="border bg-gray-100 border-gray-300 rounded-md p-2"
                defaultValue={selectedCountry}
                onChange={(e) => setSelectedCountry(e.target.value)}
              >
                {countries.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.name}
                  </option>
                ))}
              </select>
              <div className="relative">
                <input
                  id="phone"
                  type="tel"
                  placeholder="Phone number"
                  className="w-full border bg-gray-100 border-gray-300 rounded-md p-2 pl-16"
                  required
                  value={phoneNumber}
                  onChange={handlePhoneNumberChange}
                />
                <span className="absolute left-3 top-2 text-gray-500">{phoneCode}</span>
              </div>
            </div>
          </div>

          <div className="space-y-2">
            <label htmlFor="help" className="text-sm text-gray-600">
              How can we help?<span className="text-red-500">*</span>
            </label>
            <p className="text-sm text-gray-500">
              Describe your project & business goals for our team to promptly get back to you.
            </p>
            <textarea
              id="help"
              placeholder="Budget, scope, timelines, technologies"
              rows={5}
              className="w-full border bg-gray-100 border-gray-300 rounded-md p-2"
              required
            />
          </div>

          <div className="space-y-4">
            <div className="g-recaptcha" data-sitekey="your-recaptcha-site-key"></div>
            <button
              type="submit"
              className="w-full bg-[#5f5ca8] hover:bg-[#504e9a] text-white py-2 px-4 rounded-md transition-colors"
            >
              Submit
            </button>
          </div>
        </motion.div>
      </div>
    </div>
  </div>

  <div className="max-w-7xl mx-auto px-4 py-12">
    <h2 className="text-[#504e9a] font-medium mb-4">Our Offices</h2>
    <h3 className="text-3xl font-semibold text-gray-800 mb-8">
      Need to find a VentureDive office near you?
    </h3>

    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {offices.map((office) => (
        <div
          key={office.id}
          className="relative h-[400px] overflow-hidden cursor-pointer flex items-end p-6"
          onMouseEnter={() => setHoveredOffice(office.id)}
          onMouseLeave={() => setHoveredOffice(null)}
        >
          <div className="absolute inset-0">
            <img
              src={office.image || "/placeholder.svg"}
              alt={`${office.name} office`}
              className="w-full h-full object-cover transition-all duration-300 ease-in-out"
            />
            <div
              className={`absolute inset-0 bg-[#504e9a] transition-all duration-300 ease-in-out ${
                hoveredOffice === office.id ? "translate-y-0 opacity-60" : "translate-y-full opacity-40"
              }`}
            />
          </div>

          <div className="relative w-full text-white flex flex-col justify-end transition-all duration-300">
            {hoveredOffice !== office.id && (
              <h4 className="text-2xl font-bold transition-opacity duration-300">
                {office.name}
              </h4>
            )}

            {hoveredOffice === office.id && (
              <div className="opacity-100 transition-opacity duration-300">
                <p className="font-bold text-lg">{office.city}</p>
                <p className="text-sm">{office.location}</p>
                <p className="text-sm mt-2">{office.phone}</p>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

  );
};

export default ContactUs;

